module.exports = __webpack_public_path__ + "static/img/craigOne.0033cb14.png";